import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ContentHeader from 'component/utils/ContentHeader'
import SideFilterDemarcate from 'component/justificationDemarcateNew/SideFilterDemarcate'
import Pagination from 'component/pagination/Pagination'
import Button from 'component/Button'
import Col from 'component/utils/Col'
import Notification from 'component/utils/Notification'
import ModalNewJustification from 'component/justificationDemarcateNew/ModalNewJustification'
import EditModal from 'component/justificationDemarcateNew/EditModal'
import SuccessModal from 'component/Modal/SuccessModal'
import Table from 'component/justificationDemarcateNew/TableJustificationDemarcate'
import FilterIconSVG from 'component/svgComponents/filter'
import * as demarcateJustificationsActions from 'action/demarcateJustifications'

const PER_PAGE = 10

const DEFAULT_FILTER = {
  typeJustification: ['request', 'reproval'],
  status: [0, 1],
}

const JustificationDemarcateNew = ({
  auth: { user },
  translate,
  fetchDemarcateJustifiesList,
  fetchDemarcateJustifiesSaveAndUpdate,
  fetchDemarcateJustifiesDelete,
  justificationsStored,
}) => {
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [showEditModal, setShowEditModal] = useState(false)
  const [valueToEdit, setValueToEdit] = useState({})
  const [justifications, setJustifications] = useState([])
  const [pagination, setPagination] = useState({})
  const [page, setPage] = useState([])
  const [activePage, setActivePage] = useState(1)

  useEffect(() => {
    fetchJustifies()
  }, [])

  useEffect(() => {
    setJustifications(justificationsStored)
    const numberOfRegister = justificationsStored.length
    const currentPage = activePage
    const count = currentPage * PER_PAGE - PER_PAGE
    const contentPage = justificationsStored.slice(count, count + PER_PAGE)

    setPage(contentPage)

    setPagination({
      page: activePage,
      size: contentPage.length,
      offset: page - 1,
      perPage: PER_PAGE,
      pageCount: Math.ceil(numberOfRegister / PER_PAGE),
      totalCount: numberOfRegister,
    })
  }, [justificationsStored])

  useEffect(() => {
    const count = pagination.page * PER_PAGE - PER_PAGE
    const newPage = justifications.slice(count, count + PER_PAGE)
    setPage(newPage)
  }, [pagination])

  const fetchJustifies = (params = DEFAULT_FILTER) => {
    fetchDemarcateJustifiesList(user.dsToken, params)
  }

  const saveAndUpdateJustifies = (params) => {
    fetchDemarcateJustifiesSaveAndUpdate(user.dsToken, params)
  }

  const changeFilterValues = (statusValue) => {
    const filterParams = {
      typeJustification: statusValue.type.param,
      status: statusValue.status.param,
    }
    setSideFilterVisible(false)
    fetchJustifies(filterParams)
    setActivePage(1)
  }

  const submitNewJustifications = (values) => {
    const newJustifiesParams = {
      typeJustification: values.justifies.type.param,
      newJustifications: values.justifies.values.map((item) => ({
        dsJustification: item.dsJustification,
      })),
    }

    saveAndUpdateJustifies(newJustifiesParams)
    setIsVisible(false)
    setSuccessMessage('config.pricebannerConfig.saveSuccess.2')
    setShowSuccessModal(true)
  }

  const handleUpdateJustification = (editedJustification) => {
    const editedJustifiesParams = {
      typeJustification: editedJustification.typeJustification,
      newJustifications: [
        {
          idJustification: editedJustification.idJustification,
          dsJustification: editedJustification.dsJustification,
          inInactive: editedJustification.inInactive,
        },
      ],
    }
    setShowEditModal(false)
    saveAndUpdateJustifies(editedJustifiesParams)
    if (!editedJustification.isToggleUpdate) {
      setSuccessMessage('config.pricebannerConfig.saveSuccess.4')
      setShowSuccessModal(true)
    }
  }

  const deleteJustification = (value) => {
    const deleteJustification = {
      typeJustification: value.typeJustification,
      idJustification: value.idJustification,
    }
    fetchDemarcateJustifiesDelete(user.dsToken, deleteJustification)
    setSuccessMessage('config.pricebannerConfig.saveSuccess.6')
    setShowSuccessModal(true)
  }

  const setUpdateModal = (record) => {
    setValueToEdit(record)
    setShowEditModal(true)
  }

  const changePage = (page) => {
    setActivePage(page)
    setPagination({ ...pagination, page })
  }

  const renderTable = () =>
    page.length ? (
      <Table
        handleDelete={deleteJustification}
        openEditModal={setUpdateModal}
        records={page}
        toggleInInactive={(values) => handleUpdateJustification(values)}
        translate={translate}
      />
    ) : (
      <Col
        xs={12}
        className='margin-top margin-right'
        style={{ marginLeft: `${sideFilterVisible ? 0.5 : 1}rem` }}
      >
        <Notification
          message={translate('no.data.found')}
          className='notification-warning'
        />
      </Col>
    )

  const renderPagination = () =>
    pagination.pageCount > 1 ? (
      <Col className='align-center margin-bottom margin-top-triple new-style-pagination'>
        <Pagination
          count={pagination.pageCount}
          current={pagination.page}
          getPage={(page) => changePage(page)}
          pages={pagination.pageCount}
        />
      </Col>
    ) : (
      ''
    )
  return (
    <div className='new-demarcate-justification'>
      <ContentHeader>
        {translate('demarcate.justifies.header.title')}
      </ContentHeader>
      <div className='control-header'>
        <div className='demarcate-justification-button'>
          <Button
            className='btn btn-primary'
            text={translate('demarcate.justifies.button.newJustify.label')}
            onClick={() => setIsVisible(true)}
          />
        </div>
        <div className='demarcate-filter-button'>
          <Button
            className='btn btn-secondary'
            text={translate('commonReport.filters')}
            onClick={() => setSideFilterVisible(true)}
            svgIcon
            svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
          />
        </div>
      </div>
      <div className='table-justification-standard'>
        {renderTable()}
        <div>{renderPagination()}</div>
      </div>
      <SideFilterDemarcate
        changeFilterValues={changeFilterValues}
        visible={sideFilterVisible}
        setIsOpen={() => setSideFilterVisible(!sideFilterVisible)}
        translate={translate}
      />
      {isVisible && (
        <div className='demarcate-modal-new-justification'>
          <ModalNewJustification
            closeModal={setIsVisible}
            handleFilters={submitNewJustifications}
            translate={translate}
          />
        </div>
      )}
      {showSuccessModal && (
        <SuccessModal
          t={translate}
          handleClose={() => setShowSuccessModal(false)}
          size='md'
          msg={translate(`${successMessage}`)}
        />
      )}
      {showEditModal && (
        <EditModal
          closeModal={() => setShowEditModal(false)}
          value={valueToEdit}
          submit={(value) => handleUpdateJustification(value)}
          translate={translate}
        />
      )}
    </div>
  )
}

JustificationDemarcateNew.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchDemarcateJustifiesList: PropTypes.func.isRequired,
  fetchDemarcateJustifiesSaveAndUpdate: PropTypes.func.isRequired,
  fetchDemarcateJustifiesDelete: PropTypes.func.isRequired,
  justificationsStored: PropTypes.array.isRequired,
}

const mapStateToProps = ({ demarcateJustificationsReducer }) => ({
  justificationsStored: demarcateJustificationsReducer.list,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(demarcateJustificationsActions, dispatch)

const JustificationDemarcateNewTranslated = translate(null, { wait: true })(
  JustificationDemarcateNew
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JustificationDemarcateNewTranslated)

export { JustificationDemarcateNew }
